var _stop, _stop2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";

function SvgWorkspace(props) {
  var _id = useUniqueInlineId();

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 31",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.332 0c2.975 0 5.577 1.564 6.97 3.892l.25.044.625.122.601.13c3.636.835 5.887 2.197 5.887 4.01 0 2.023-2.798 3.483-7.195 4.277l.037-.068c-1.365 2.593-4.119 4.258-7.175 4.258-2.957 0-5.632-1.56-7.039-4.01l-.099-.18C2.797 11.682 0 10.221 0 8.198c0-2.048 2.869-3.52 7.363-4.306C8.756 1.563 11.358 0 14.333 0zm4.9 12.802l-.407.045c-1.43.148-2.944.225-4.493.225-1.697 0-3.351-.093-4.901-.27C10.622 14.169 12.398 15 14.332 15c1.934 0 3.71-.832 4.9-2.198zM22.1 5.746l.043.158c.033.128.062.258.089.388 1.056.38 1.65.86 1.65 1.54 0 .807-.84 1.334-2.301 1.744-.456.128-.971.243-1.53.34-1.618.285-3.615.441-5.719.441-2.107 0-4.104-.156-5.718-.44a15.621 15.621 0 01-1.531-.341c-1.46-.41-2.301-.937-2.301-1.745 0-.679.594-1.159 1.651-1.539.037-.185.081-.368.131-.547-3.05.67-4.9 1.683-4.9 2.453 0 .786 1.923 1.823 5.081 2.492l.627.125c.213.04.432.078.656.115 1.915.311 4.068.477 6.304.477 2.236 0 4.39-.166 6.305-.477.223-.037.442-.075.656-.115l.626-.125C25.077 10.02 27 8.984 27 8.198c0-.77-1.85-1.782-4.9-2.452zm-7.768-4.081C10.8 1.665 7.95 4.414 7.95 7.79c0 .278.02.554.058.827l.006.049c.25.056.514.109.792.157 1.549.273 3.482.425 5.527.425 2.043 0 3.976-.152 5.529-.425.277-.048.54-.1.79-.157l-.038.222c.068-.36.103-.727.103-1.098 0-3.376-2.851-6.125-6.384-6.125zM5.892 7.83c0 .042.134.147.4.277l-.008-.318.003-.233c-.262.129-.396.233-.396.274zm16.486-.274l.002.233-.006.318c.059-.03.111-.057.157-.083l.134-.083c.072-.05.108-.089.108-.11 0-.042-.133-.146-.395-.275z",
    transform: "rotate(-39 25.537 8.855)",
    fill: "url(#".concat(_id, ")")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "99.063%",
    x2: "50%",
    y2: "0%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#664FF9",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1253FA",
    offset: "100%"
  })))));
}

export default SvgWorkspace;